import React, { useRef, useState, useEffect } from 'react';
import DragHandleIcon from '@shared/components/Tiptap/DragHandleIcon';
import BlockItemMenu from './BlockItemMenu';
import { NodeViewProps } from '@tiptap/react';

const DragHandle = (props: NodeViewProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const iconRef = useRef<HTMLSpanElement>(null);

  const handleDragHandleIconClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setMenuOpen(open => !open);
  };

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (iconRef.current && !iconRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <span
      className="drag-handle"
      contentEditable={false}
      draggable="true"
      data-drag-handle
      ref={iconRef}
    >
      <DragHandleIcon onClick={handleDragHandleIconClick} />
      {!menuOpen && (
        <span className="block-item-tooltip">
          <strong className="block-item-tooltip-action">Drag</strong>
          <span className="block-item-tooltip-desc"> to move</span>
          <br />
          <strong className="block-item-tooltip-action">Click</strong>
          <span className="block-item-tooltip-desc"> to open menu</span>
        </span>
      )}
      {menuOpen && <BlockItemMenu {...props} />}
    </span>
  );
};

export default DragHandle;
